export const ROLE_ADMIN = 'admin'
export const ROLE_CANDIDATE = 'candidate'
export const ROLE_COMPANY_OWNER = 'company_owner'
export const ROLE_COMPANY_STAFF = 'company_staff'
export const ROLE_CONSULTANT = 'consultant'
export const ROLE_RECRUITER = 'recruiter'
export const ROLE_BOT = 'bot'
export const ROLE_DIVISION_HEAD = 'division_head'
export const ROLE_MARKETING_MANAGER = 'marketing_manager'
export const ROLE_BUSINESS_MANAGER = 'business_manager'
export const ROLE_CONTENT_MANAGER = 'content_manager'
export const ROLE_SALES_MANAGER = 'sales_manager'
export const ROLE_RECRUITING_HEAD = 'recruiting_head'
export const ROLE_CUSTOMER_SUPPORT = 'customer_support'

export const ROLES = [
  ROLE_ADMIN,
  ROLE_CANDIDATE,
  ROLE_COMPANY_OWNER,
  ROLE_COMPANY_STAFF,
  ROLE_CONSULTANT,
  ROLE_RECRUITER,
  ROLE_BOT,
  ROLE_DIVISION_HEAD,
  ROLE_MARKETING_MANAGER,
  ROLE_BUSINESS_MANAGER,
  ROLE_CONTENT_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_RECRUITING_HEAD,
  ROLE_CUSTOMER_SUPPORT
]
